export const TAB_NAMES = {
  MAIN: 'main',
  CHANNEL: 'channel',
  LAYOUT: 'layout',
  SETTINGS: 'settings',
  DESIGN: 'design',
};

export default [
  TAB_NAMES.MAIN,
  TAB_NAMES.CHANNEL,
  TAB_NAMES.LAYOUT,
  TAB_NAMES.SETTINGS,
  TAB_NAMES.DESIGN,
];



// WEBPACK FOOTER //
// ./src/shared/constants/app-settings-tabs.js